import { render, staticRenderFns } from "./QualityTab.vue?vue&type=template&id=2b99e2a0&"
import script from "./QualityTab.vue?vue&type=script&lang=ts&"
export * from "./QualityTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports